import type { TicketStatusRef } from '../api/types';

export function formatStatus(status: TicketStatusRef | string): string {
  if (typeof status === 'string') return status.replace(/_/g, ' ');
  return status.name;
}

export function formatLabel(label: { code: string; name: string } | string): string {
  if (typeof label === 'string') return label.replace(/_/g, ' ');
  return label.name;
}

export function formatLabels(labels: { name: string }[]): string {
  if (labels.length === 0) return '—';
  return labels.map((l) => l.name).join(', ');
}

export function statusBadgeClass(status: TicketStatusRef | string): string {
  const code = typeof status === 'string' ? status : status.code;
  switch (code) {
    case 'COMPLETED':
      return 'badge-success';
    case 'IN_PROGRESS':
      return 'badge-info';
    case 'CANNOT_RESOLVE':
      return 'badge-danger';
    case 'ON_HOLD':
    case 'DEFERRED':
      return 'badge-warning';
    case 'TO_DO':
    case 'OPEN':
    case 'NEW':
      return 'badge-neutral';
    default:
      return 'badge-neutral';
  }
}

export function priorityRowClass(priority: string): string {
  switch (priority) {
    case 'URGENT':
      return 'priority-urgent';
    case 'HIGH':
      return 'priority-high';
    case 'MEDIUM':
      return 'priority-medium';
    case 'LOW':
      return 'priority-low';
    default:
      return 'priority-none';
  }
}

export function priorityBadgeClass(priority: string): string {
  switch (priority) {
    case 'URGENT':
    case 'HIGH':
      return 'badge-danger';
    case 'MEDIUM':
      return 'badge-warning';
    case 'LOW':
      return 'badge-info';
    default:
      return 'badge-neutral';
  }
}

export function resolveAllowedStatusIds(
  currentStatusId: string,
  workflow: { transitions: Record<string, string[]> },
): string[] {
  return workflow.transitions[currentStatusId] ?? [];
}
